<template>
  <div class="popups" :style="{ 'z-index': 998 }">
    <color-picker :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <color-picker-cloud :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <font-family :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <vipSprites :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <shortcuts :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <soundtrackDialog v-if="getSoundtrackState"></soundtrackDialog>
    <soundClip v-if="getsoundtrackClipState" />
    <smartVoice v-if="smartVoiceDialogVisible"></smartVoice>
    <vip-dialog :modalName="'subtitleVipDialog'"></vip-dialog>
  </div>
</template>

<script>
//  弹窗组件，所欲设置的弹窗组件
import { mapGetters } from "vuex";
import colorPickerCloud from "@/components/popups/colorCloud.vue";
import colorPicker from "@/components/popups/colorPicker.vue";
import fontFamily from "@/components/popups/fontFamily.vue"; // 一级弹窗-文字字体功能设置 （可触发关闭式）
import vipSprites from "@/components/popups/vipPopups/vipSprites.vue";
import shortcuts from "@/components/popups/shortcuts.vue";
import vipDialog from "@/components/topnav/vipDialog.vue";
import soundtrackDialog from "@/components/subtitle/dialogs/soundtrackDialog.vue";
import soundClip from "@/components/subtitle/soundtrack/soundClip.vue";
import smartVoice from "./dialogs/smartVoiceDialog.vue";
import addSound from '@/components/rightnav/slide/addSound.js';
export default {
  mixins: [addSound],
  data() {
    return {
      boxDatas: {
        firstDatas: [], // 一级弹窗数据数组，控制层级（可触发关闭式）
        secondData: [], // 二级弹窗数据数组，控制层级（主动需要关闭操作的弹窗）
      },
      dataMsg: {},
      actionBox: false,
      Pindex: 25,
      stopClose: false,
    };
  },
  created() {},
  computed: {
    ...mapGetters({
      TopNav_Size: "TopNav_Size",
      TOOL: "TOOL",
      getSoundtrackState: "addSoundtrack/getSoundtrackState",
      getsoundtrackClipState: "soundtrackSet/getsoundtrackClipState",
      smartVoiceDialogVisible: "smartVoice/smartVoiceDialogVisible",
      startType: 'subtitle/startType',
      musicArr: 'addSoundtrack/getMusicArr',
      dubbingArr: 'addSoundtrack/getDubbingArr'
    }),
  },
  mounted() {
    // this.$store.commit("smartVoice/setSmartVoiceDialogVisible", true);
    if (this.startType === 'upload' || this.startType === 'record') {
      // let sound = this.findMin(this.dubbingArr);
      // let toolDur = this.TOOL.getDuration() / 1000;
      // let end = sound ? sound.timeSlot[0] : toolDur;
      // this.$store.commit("addSoundtrack/setSoundtrackState", {
      //   state: true,
      //   type: 'dub',
      //   start: 0,
      //   end,
      //   index: 0,
      //   operation: "add",
      // });
      this.setSceneTiming();
    }
    if (this.startType === 'smart') {
      // let sound = this.findMin(this.dubbingArr);
      // let toolDur = this.TOOL.getDuration() / 1000;
      // let end = sound ? sound.timeSlot[0] : toolDur;
      // this.$store.commit("addSoundtrack/setSoundtrackState", {
      //   state: true,
      //   type: 'dub',
      //   start: 0,
      //   end: end,
      //   index: 0,
      //   operation: "add",
      // });
      this.setSceneTiming(true);
      this.$store.commit("smartVoice/setSmartVoiceDialogVisible", true);
      this.$store.commit("addSoundtrack/setSoundtrackState", {state: false});
    }

    this.$store.commit('subtitle/setStartType', '');
    this.$bus.on("subtitlePopup", (data) => {
      let rightKey = Array.indexOf(
        this.boxDatas.firstDatas,
        "color-cloud"
      );
      if (rightKey >= 0) {
        this.$bus.emit("subtitlePopupClose", {
          name: "color-cloud",
          type: 1,
        });
      }
      this.dataMsg[data.name] = data;
      // 进出场设置弹窗 enterExitEffect.vue 将要显示时，先关闭其他一级弹窗
      if (data.name === "effect" || data.name === "inOutEffect") {
        this.$set(this.boxDatas, "firstDatas", []);
      }
      switch (data.name) {
        case "vipEquity":
        case "vipPayment":
        case "color":
          this.Pindex = 40;
          break;
        default:
          this.Pindex = 25;
          break;
      }
      if (data.type === 1) {
        // 一级可被触发关闭弹窗
        let judgeOnlyOne = Array.indexOf(this.boxDatas.firstDatas, data.name);
        if (judgeOnlyOne === -1) {
          this.boxDatas.firstDatas.push(data.name);
        } else {
          return;
        }
      } else if (data.type === 2) {
        // 二级弹窗主动关闭切换关闭
        let judgeOnlyOne = Array.indexOf(this.boxDatas.secondData, data.name);
        if (judgeOnlyOne === -1) {
          this.boxDatas.secondData.push(data.name);
        } else {
          return;
        }
      }
      this.actionBox = true;
    });
    this.$bus.on("subtitlePopupClose", (data) => {
      // 关闭弹窗，一，二级弹窗
      if (data.name === "setting_Bg" && this.stopClose) {
        this.stopClose = false;
        return;
      }
      if (data.type === 1) {
        let index = this.boxDatas.firstDatas.indexOf(data.name);
        if (index > -1) {
          this.boxDatas.firstDatas.splice(index, 1);
        }
      }
      if (data.type === 2) {
        let index = this.boxDatas.secondData.indexOf(data.name);
        if (index > -1) {
          this.boxDatas.secondData.splice(index, 1);
        }
      }
      if (data.type === 3) {
        // 关掉所有弹窗
        let dataMsgObject = {};
        let dataMsgList = [];
        if (this.dataMsg.vipEquity) {
          dataMsgObject.vipEquity = Object.assign(this.dataMsg.vipEquity);
          dataMsgList.push(dataMsgObject.vipEquity.name);
        }
        this.boxDatas.firstDatas = [];
        this.boxDatas.secondData = dataMsgList;
        this.dataMsg = dataMsgObject;
      }
      if (data.name) {
        delete this.dataMsg[data.name];
      }
      this.closeBoxJudgeZindex();
    });
    // window.onmousedown = (event) => {
    //   if (event.target.closest(".stroke-width-dropdown")) {
    //     return;
    //   }
    //   this.$bus.emit("windowMousedown_vue", { data: true });
    //   if (this.boxDatas.firstDatas.length) {
    //     // 触发关闭弹窗
    //     for (let i = 0; i < this.boxDatas.firstDatas.length; i++) {
    //       delete this.dataMsg[this.boxDatas.firstDatas[i]];
    //     }
    //     this.boxDatas.firstDatas = [];
    //   }
    // };
    document.onmousemove = (event) => {
      this.$bus.emit("Document_mousemove_vue", event);
    };
    document.onmouseup = (event) => {
      this.$bus.emit("Document_mouseup_vue", event);
    };
    document.onmouseleave = (event) => {
      this.$bus.emit("Document_mouseup_vue", event);
    };

    this.$bus.on("bgZoom.playScene", () => {
      this.stopClose = true;
    });
  },
  methods: {
    findMin (arr) {
      let minData = arr[0];
      arr.forEach(v => {
        if (v.timeSlot[0] < minData.timeSlot[0]) {
          minData = v;
        }
      });
      return minData;
    },
    closeBoxJudgeZindex() {
      let Boxname = ["vipEquity", "vipPayment", "color"];
      for (let i = 0; i < Boxname.length; i++) {
        if (Boxname[i] in this.dataMsg) {
          this.Pindex = 40;
          break;
        } else {
          this.Pindex = 25;
        }
      }
    },
  },
  components: {
    colorPicker,
    colorPickerCloud,
    fontFamily,
    vipSprites,
    vipDialog,
    soundtrackDialog,
    soundClip,
    smartVoice,
    shortcuts
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.popups {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 24;
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/subtitlePopups.vue